(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BingoClient", [], factory);
	else if(typeof exports === 'object')
		exports["BingoClient"] = factory();
	else
		root["BingoClient"] = factory();
})(self, function() {
return 